import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7387728f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article-content-wrap" }
const _hoisted_2 = { class: "articles-left" }
const _hoisted_3 = { class: "article-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "article-title" }
const _hoisted_6 = { class: "article-time" }
const _hoisted_7 = {
  key: 0,
  class: "loading-more"
}
const _hoisted_8 = { class: "articles-right" }
const _hoisted_9 = {
  key: 0,
  class: "loading-win"
}
const _hoisted_10 = {
  key: 1,
  class: "article-detail"
}
const _hoisted_11 = { class: "article-detail-title" }
const _hoisted_12 = { class: "article-detail-from" }
const _hoisted_13 = { class: "detail-from-time" }
const _hoisted_14 = {
  key: 0,
  class: "detail-from-source"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "disclaimer"
}
const _hoisted_17 = { class: "report-btn-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["article-container", _ctx.theme])
  }, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumb, (item) => {
          return (_openBlock(), _createBlock(_component_a_breadcrumb_item, {
            key: item.title
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articleList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.newsId,
              class: _normalizeClass({ 'selected-article': _ctx.currentNewsId === item.newsId }),
              onClick: ($event: any) => (_ctx.selectArticle(item.newsId))
            }, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.showTime), 1)
            ], 10, _hoisted_4))
          }), 128))
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "加载中..."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.detailLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_a_spin, { tip: "加载中..." })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.articleDetail.title), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, "发布于 " + _toDisplayString(_ctx.formatTime(_ctx.articleDetail.showTime)), 1),
                (_ctx.articleDetail.source)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "来源:" + _toDisplayString(_ctx.articleDetail.source), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "article-detail-content",
                innerHTML: _ctx.articleDetail.content
              }, null, 8, _hoisted_15),
              (_ctx.articleDetail.disclaimers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.articleDetail.disclaimers), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                (_ctx.currentNewsId)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "report-btn",
                      id: "report",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoReport($event)))
                    }, "举报"))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ])
  ], 2))
}